import { has, isArray, isPlainObject } from "lodash";
import { Filters } from "@/services/api/types";

// Leaf module: the API hooks collapse filters before every request, so this
// must not pull in the filter-options hook, which itself reaches the API hooks.

export const isNotInFilter = (value: unknown): value is { not_in: unknown } => {
  return isPlainObject(value) && has(value, "not_in");
};

export const collapseNoValueFilters = (filters: Filters): Filters => {
  const result: Filters = {};
  for (const key of Object.keys(filters)) {
    const value = filters[key];
    if (isArray(value) && value.length === 1 && value[0] === null) {
      result[key] = null;
    } else if (
      isNotInFilter(value) &&
      isArray(value.not_in) &&
      value.not_in.length === 1 &&
      value.not_in[0] === null
    ) {
      result[key] = "not_null";
    } else {
      result[key] = value;
    }
  }
  return result;
};
